import React, { useState, useEffect } from "react";

interface FormState {
    load: boolean;
    recaptchaLoaded: boolean;
    formErrors: Record<string, string[]>;
    captchaValue: string | null;
}

interface FormProps {
    title?: string | null | undefined;
    onSubmit?: (formData: FormState) => void;
    children: React.ReactNode;
}

const BaseFormContainer: React.FC<FormProps> = ({ title = null, onSubmit, children }) => {
    const [state, setState] = useState<FormState>({
        load: false,
        recaptchaLoaded: false,
        formErrors: {},
        captchaValue: null,
    });

    const asyncScriptOnLoad = () => {
        setState((prevState) => ({ ...prevState, recaptchaLoaded: true }));
    };

    const getError = (fieldName: string): string | null => {
        const errors = state.formErrors[fieldName];
        return errors && errors.length > 0 ? errors[0] : null;
    };

    const onCaptchaChange = (val: string | null) => {
        if (val !== null) {
            setState((prevState) => ({ ...prevState, captchaValue: val }));
        }
    };

    const submitForm = () => {
        if (onSubmit) {
            onSubmit(state);
        }
    };

    useEffect(() => {
        if (state.captchaValue !== null) {
            submitForm();
        }
    }, [state.captchaValue]);

    return (
        <form onSubmit={(e) => e.preventDefault()}>
            {title && <h1>{title}</h1>}
            {children}
        </form>
    );
};

export default BaseFormContainer;
